import commonsApi from '@/api/commons'

// initial state

const state = {
  tableItems: [],
  aggregates: [],
  csvItems: [],
  tableItemsTotal: 0,
  itemDetail: {},
  loading: true
}

const mutations = {
  mutateTableItems (state, response) {
    state.tableItems = response.items
    state.tableItemsTotal = response.total
    state.aggregates = response.aggregates
  },
  mutateCsvItems (state, response) {
    state.csvItems = response.items
  },
  mutateLoading (state, loading) {
    state.loading = !!loading
  },
  mutateItemDetail (state, response) {
    state.itemDetail = response
  }
}

const actions = {
  async getItems ({ commit }, response) {
    commit('mutateLoading', true)
    const items = await commonsApi.getItems(response)
    commit('mutateTableItems', items)
    commit('mutateLoading', false)
  },
  async getItemDetail ({ commit }, response) {
    commit('mutateLoading', true)
    const item = await commonsApi.getItemDetail(response)
    commit('mutateItemDetail', item)
    commit('mutateLoading', false)
  },
  async updateItemDetail ({ commit, state }, item) {
    commit('mutateLoading', true)
    await commonsApi.updateItemDetail(item.path, item.data)
    commit('mutateLoading', false)
  },
  async getCsvItems ({ commit }, response) {
    const item = await commonsApi.getItems(response)
    commit('mutateCsvItems', item)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
